module.exports = __webpack_public_path__ + "static/img/icon2.0ac0b5c6.png";